<script>

import Swiper from '@/utils/verticalSwiper'
import '@/utils/verticalSwiper.css'
import http from '@/utils/http'
import { mapState } from 'vuex'
import lottie from 'lottie-web'
import animationData from '@/assets/banner.json'

export default {

  data () {
    return {
      banner: [],
      isReverse: false,
      autoplay: false
    }
  },
  computed: {
    ...mapState(['pn', 'aid', 'pkg', 'uid', 'channel', 'code'])
  },
  mounted () {
    this.anim = lottie.loadAnimation({
      container: this.$refs.lottieRef, // DOM容器
      renderer: 'svg',                 // 渲染方式
      loop: true,                      // 是否循环
      autoplay: true,                  // 自动播放
      animationData                   // JSON数据
    })
    this.checkIsReverse()
    // this.requestBannerData()

  },
  methods: {

    checkIsReverse () {
      if (window.matchMedia('(orientation: portrait)').matches) {
        this.isReverse = true
      } else if (window.matchMedia('(orientation: landscape)').matches) {
        this.isReverse = false
      }
    },

    // requestBannerData () {
    //   const requestBody = {
    //     pn: this.pn,
    //     aid: this.aid,
    //     pkg: this.pkg,
    //     uid: this.uid,
    //     code: this.code,
    //     channel: this.channel
    //   }
    //   http.postHttp('/customizedCarousel/queryConfigure', JSON.stringify(requestBody)).then((reps) => {
    //     if (reps.code !== 0) {
    //       return
    //     }
    //     this.banner = reps.data.list
    //     this.autoplay = reps.autoplay
    //     this.$nextTick(() => {
    //       // eslint-disable-next-line no-new
    //       new Swiper('.banner-contain', {
    //         isReverse: this.isReverse,
    //         loop: true
    //       })
    //     })
    //   })
    // }
  }
}
</script>

<template>
  <div class="banner-contain" ref="lottieRef"></div>
  <!-- <div class="swiper-contain banner-contain">
    <div  class="swiper-wrapper">
      <img  class="swiper-slide" v-for="item in banner" :key="item.length" :src="item.carouselEnUrl"/>
    </div>
  </div> -->
</template>

<style scoped>

.banner-contain {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: auto;
}
</style>
